export default __webpack_public_path__ + "locales/de/Files.json?hash=c52731c131d2caa1e295018c7efc0265";